import React, { useEffect, useState } from 'react';
import { Mask } from 'antd-mobile';

import cx from './index.module.scss';

interface Props {
  open: boolean;
  children: React.ReactNode;
  className?: string;
  onClickMask?: VoidFunc;
  contentClassName?: string;
}

const SlideModal: React.FC<Props> = ({ className, open, children, contentClassName, onClickMask }) => {
  const [controlDomShow, setControlDomShow] = useState(open);

  useEffect(() => {
    let timer = null;
    if (open) {
      timer = setTimeout(() => setControlDomShow(true), 50);
    } else {
      setControlDomShow(false);
    }
    return () => {
      clearTimeout(timer);
      timer = null;
    };
  }, [open]);

  return (
    <Mask getContainer={document.body} visible={open} className={cx('SlideModal', { open }, className)}>
      <div className={cx('content', contentClassName, { show: controlDomShow })}>{children}</div>
    </Mask>
  );
};

export default SlideModal;
